import { getFingerprint as loadFingerprint } from "@thumbmarkjs/thumbmarkjs";
import { flow, types } from "mobx-state-tree";

export const FingerprintStore = types
  .model({
    fingerprint: types.maybe(types.string)
  })
  .actions((self) => ({
    generate: flow(function* generate() {
      self.fingerprint = yield getFingerprint();
    })
  }));

const getFingerprint = async (): Promise<string> => {
  const visitorId = await loadFingerprint(false);

  return visitorId as string;
};
